import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from './session-storage.service';

@Injectable({
    providedIn: 'root'
})
export class DevToolService {
    private readonly sessionStorageService = inject(SessionStorageService);

    private DEVTOOL_ENABLED_KEY = 'isDevToolEnabled';

    validateAccess(): boolean {
        return this.sessionStorageService.getItem(this.DEVTOOL_ENABLED_KEY)?.toString() === 'true';
    }

    enableAccess(): void {
        this.sessionStorageService.setItem(this.DEVTOOL_ENABLED_KEY, true);
    }
}